import React from 'react';
import styles from './About.module.css';
import image from '../../assets/image.webp';

const About = () => {
  return (
    <section className={styles.container} id="about">
      <div>
        <img className={styles.image} src={image} alt="" />
      </div>
      <div>
        <h2 className={styles.heading}>關於我們 About Us</h2>
        <p className={styles.text}>
          「新青匯」為慈善註冊團體（慈善團體註冊編號：91/10882），新青匯義工隊成立於2014年，
          由在港內地青年、香港本地青年及在港少數族裔青年組成。 宗旨：
        </p>
        <ul className={styles.list}>
          <li>
            鼓勵新來港、本地及少數族裔青年發揮自己才能，並為他們在香港及內地提供必要的社會資源，幫助他們更好地實現自己的理想；
          </li>
          <li>
            搭建新来港、香港本地及少數族裔青年之間的溝通橋樑及平台，通過互相交流活動，增進了解，促進溝通，推動多元文化發展及社會共融；
          </li>
          <li>
            鼓勵在港青年積極參與社會實踐活動，關心時政，向社會展示青年間共融團結的力量。
          </li>
        </ul>
      </div>
    </section>
  );
};

export default About;
